module.exports = {"id":"186302","name":"Elías Hernández","rating":"78","photo":"./data/images/photos/4/186302.png","club":{"name":"León","logo":"./data/images/clubs/Leon.png"},"positions":["MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EliasHernandez0.json
// module id = 1203
// module chunks = 0